// Page choices for printing (requirement 12, Oct 2026) — no imports, so the unit tests can load it in Node.
export type PaperSize = 'A4' | 'Letter';
export type Orientation = 'portrait' | 'landscape';
export interface PrintOptions {
  /** overrides the page orientation of the document (its margins and page breaks stay) */
  orientation?: Orientation;
  /** overrides the paper size of the document */
  paper?: PaperSize;
}
/** the @page override for the chosen orientation / paper size ('' when nothing was chosen) */
export function pageOverrideCss(o: PrintOptions = {}): string {
  if (!o.orientation && !o.paper) return '';
  const paper = o.paper === 'Letter' ? 'letter' : 'A4';
  return `@page { size: ${paper}${o.orientation === 'landscape' ? ' landscape' : o.orientation === 'portrait' ? ' portrait' : ''}; }`;
}
/** the document with the override placed last (after any @page of the document's own styles, so it wins); only `size`
 *  is overridden — the document's margins, margin boxes (running header, page x of y) and page breaks stay */
export function withPrintOptions(html: string, o: PrintOptions = {}): string {
  const css = pageOverrideCss(o);
  if (!css) return html;
  const tag = `<style data-vero-print-options>${css}</style>`;
  const at = html.lastIndexOf('</body>');
  return at >= 0 ? html.slice(0, at) + tag + html.slice(at) : html + tag;
}
const unesc = (s: string) => s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
/** the document's <title> (the print window's title and the suggested PDF file name) */
export const documentTitle = (html: string) => unesc(/<title>([^<]*)<\/title>/i.exec(html)?.[1] ?? 'AVRASTRO').slice(0, 120);
